import { ShoppingCart, Star, Users, Calendar, Clock, FileText } from 'lucide-react';
import TabGrid from '@/components/ui/TabGrid';

/**
 * Shopping Tab Configuration
 * Fresh pastel green palette with subtle variations per tab
 */
const TAB_CONFIG = [
  {
    id: 'lists',
    label: 'Lists',
    icon: ShoppingCart,
    colors: {
      bg: '#F0FDF4',
      active: '#DCFCE7',
      text: '#166534',
      iconBg: '#D1FAE5',
    }
  },
  {
    id: 'favorites',
    label: 'Favorites',
    icon: Star,
    colors: {
      bg: '#FEFCE8',
      active: '#FEF9C3',
      text: '#3F6212',
      iconBg: '#ECFCCB',
    }
  },
  {
    id: 'people',
    label: 'People',
    icon: Users,
    colors: {
      bg: '#F0FDF4',
      active: '#DCFCE7',
      text: '#166534',
      iconBg: '#D1FAE5',
    }
  },
  {
    id: 'events',
    label: 'Events',
    icon: Calendar,
    colors: {
      bg: '#ECFDF5',
      active: '#D1FAE5',
      text: '#065F46',
      iconBg: '#A7F3D0',
    }
  },
  {
    id: 'history',
    label: 'History',
    icon: Clock,
    colors: {
      bg: '#F0FDF4',
      active: '#DCFCE7',
      text: '#166534',
      iconBg: '#D1FAE5',
    }
  },
  {
    id: 'templates',
    label: 'Templates',
    icon: FileText,
    colors: {
      bg: '#ECFDF5',
      active: '#D1FAE5',
      text: '#065F46',
      iconBg: '#A7F3D0',
    }
  }
];

const TABS_ORDER = ['lists', 'favorites', 'people', 'events', 'history', 'templates'];

/**
 * ShoppingTabs - Grid-based tab navigation for Shopping module
 * All tabs visible at once - no scrolling, no hidden features
 */
const ShoppingTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <TabGrid
      tabs={TAB_CONFIG}
      activeTab={activeTab}
      onTabChange={onTabChange}
      testIdPrefix="shopping-tab"
    >
      {children}
    </TabGrid>
  );
};

export { TAB_CONFIG, TABS_ORDER };
export default ShoppingTabs;
